import React, { useContext, useEffect, useState } from "react";
import HeaderWithButton from "../Utility/HeaderWithButton";
import { Dialog } from "@headlessui/react";
import { PencilSquareIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { Tooltip } from "react-tooltip";
import LeadList from "./LeadList";
import axios from "axios";
import { toast } from "react-toastify";
import Select from "react-select";
import { Country, State, City } from "country-state-city";
import { DataContext } from "../../helper/HelperOne";
// import StatesData from "./StatesDatas";
import TopFilters from "../Utility/TopFilters";
import TopStats from "../Utility/TopStats";
import { EllipsisVerticalIcon } from "@heroicons/react/20/solid";
import HeaderWithAction from "../Utility/HeaderWithAction";
import { useLocation, useNavigate } from "react-router-dom";
import LabelTopView from "../Utility/LabelTopView";
import { ChartBarBigIcon } from "lucide-react";
import UpdateConfirmation from "../Utility/UpdateConfirmation";

function LeadCreate() {

  const location = useLocation();
  const { id_crypt, showForm } = location.state || {};
  const navigate = useNavigate();



  const user = JSON.parse(localStorage.getItem("user"));
  const leadPermission = user?.lead_role_based_access?.some(
    (access) => access.label_id == 2 && access.label_value != 0
  );


  const userForEdit = JSON.parse(localStorage.getItem("user"));
  const leadPermissionForEdit =
    userForEdit?.lead_role_based_access?.some(
      (access) => access.label_id == 3 && access.label_value != 0
    );

  const [filterParams, setFilterParams] = useState("");



  const { searchData } = useContext(DataContext);
  const [isEditing, setIsEditing] = useState(false);
  const [openDialogBoxForLead, setopenDialogBoxForLead] = useState(false);
  const [saveBtn, setSaveBtn] = useState("save");
  const [saveBtnOpen, setSaveBtnOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editId, setEditId] = useState("");
  const [employeesList, setEmployeesList] = useState([]);
  const [editLeadIdCrypty, setEditLeadIdCrypty] = useState("");
  const [leadAllDatas, setLeadAllDatas] = useState([]);
  const [leadPaginationData, setLeadPaginationData] = useState([]);
  const [leadStatusData, setLeadStatusData] = useState([]);
  const [isOpenEdit, setIsOpenEdit] = useState(false);
  const [leadSourceData, setLeadSourceData] = useState([]);
  const [stats, setStats] = useState([]);
  const [typeOfWork, setTypeOfWork] = useState([]);
  const [leadDetails, setLeadDetails] = useState({
    date: new Date().toISOString().split("T")[0],
    name: "",
    lead_status_id: "",
    lead_source_id: "",
    phone: "",
    email_address: "",
    employees_id: [],
    lead_value: "",
    country_region_id: "",
    state_id: "",
    website: "",
    position: "",
    company: "",
    attention: "",
    street_address_1: "",
    street_address_2: "",
    city: "",
    pincode: "",
    type_of_work: [],
  });

  const [requiredFields, setRequiredFields] = useState({
    date: "",
    name: "",
    lead_status_id: "",
    lead_source_id: "",
    phone: "",
    email_address: "",
    lead_date: "",
    employees_id: "",
    lead_value: "",
    country_region_id: "",
    state_id: "",
    website: "",
    position: "",
    company: "",
    attention: "",
    street_address_1: "",
    street_address_2: "",
    city: "",
    state: "",
    pincode: "",
    type_of_work: "",
  });

  const [filterData, setFilterData] = useState({
    name: "",
    phone: "",
    lead_status_id: "",
    lead_source_id: "",
    lead_employee_id: ""
  });


  const statsFieldNames = [
    {
      title: "Total Leads",
      value: leadAllDatas?.length,
      color: 'blue',
      bg: "bg-blue-50",

      link: '/crm/customers'
    },
    {
      title: "Pending",
      value: stats.pendingCounts,
      color: 'red',
      bg: "bg-red-50",
      link: '/crm/customers/inactive'
    },
    {
      title: "In Progress",
      value: stats.inprogressCounts,
      color: 'yellow',
      bg: "bg-yellow-50",
      link: '/crm/customers/inactive'
    },

    {
      title: "Converted Leads",
      value: stats.convertedCounts,
      color: 'green',
      bg: "bg-green-50",
      link: '/crm/customers/inactive'
    },
    {
      title: "This Month Lead",
      value: stats.thismonthcount,
      // value: getMonthlyCustomers(leadAllDatas),
      color: 'indigo',
      bg: 'bg-purple-50',
      link: '/crm/customers/monthly'
    },
  ];


  const fetchLeadDatas = async (page = 1, queryParams = "") => {
    try {
      // Construct API URL with filters and pagination
      const leadUrl = `public/api/admin/lead/pagination?page=${page}${queryParams ? `&${queryParams}` : ""}${searchData ? `&search=${encodeURIComponent(searchData)}` : ""}`;


      const response = await axios.get(leadUrl, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });



      setStats(response.data);
      setLeadAllDatas(response.data.leads.data);
      setLeadPaginationData(response.data.leads);



      // Fetch employees data
      const employeeResponse = await axios.get(`public/api/admin/employees`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });


      setEmployeesList(employeeResponse.data.employee);

      // Fetch lead statuses
      const responseForLeadStatus = await axios.get("public/api/admin/leadstatus", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });


      setLeadStatusData(responseForLeadStatus.data.leadstatus);

      // Fetch lead sources
      const responseForLeadSource = await axios.get("public/api/admin/leadsource", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });


      setLeadSourceData(responseForLeadSource.data.leadsource);

      // Fetch type of work data
      const typeOfWorkResponse = await axios.get(`public/api/admin/type-of-work/list`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      console.log(typeOfWorkResponse.data, "typeOfWorkResponse.data");

      setTypeOfWork(typeOfWorkResponse.data);

    } catch (error) {
      console.error("Error fetching lead data: ", error);
    }
  };

  useEffect(() => {
    fetchLeadDatas();
  }, [searchData]);

  const fields = [
    {
      name: "name",
      type: "text",
      placeholder: "Name",
      componentType: "select",
      options: leadAllDatas?.map((lead) => ({
        value: lead.name,
        label: lead.name,
      })),
    },
    {
      name: "phone",
      type: "text",
      placeholder: "Phone",
      componentType: "select",
      options: leadAllDatas?.map((lead) => ({
        value: lead.phone,
        label: lead.phone,
      })),
    },
    {
      name: "lead_status_id",
      type: "text",
      placeholder: "Status",
      componentType: "select",
      options: Array.from(
        new Map(
          leadAllDatas
            ?.filter((lead) => lead.lead_status) // Ensure lead_status exists
            .map((lead) => [lead.lead_status.id, lead.lead_status]) // Store unique statuses by id
        ).values()
      ).map((status) => ({
        value: status.id, // ID as the value
        label: status.name, // Name as the label
      })),
    }
    ,
    {
      name: "lead_source_id",
      type: "text",
      placeholder: "Source",
      componentType: "select",
      options: Array.from(
        new Map(
          leadAllDatas
            ?.filter((lead) => lead.lead_source) // Ensure lead_source exists
            .map((lead) => [lead.lead_source.id, lead.lead_source]) // Store unique sources by id
        ).values()
      ).map((source) => ({
        value: source.id, // ID as the value
        label: source.name, // Name as the label
      })),
    }
    ,
    {
      name: "lead_employee_id",
      type: "text",
      placeholder: "Employee",
      componentType: "select",
      options: Array.from(
        new Map(
          leadAllDatas
            ?.flatMap((lead) =>
              lead.lead_employee?.map((employee) => [employee.id, employee]) || []
            )
        ).values()
      ).map((employee) => ({
        value: employee.id,
        label: employee.name,
      })),
    }




  ];

  const handleChange = (e) => {
    setFilterData({ ...filterData, [e.target.name]: e.target.value });
  };



  const handleFilter = async () => {
    try {
      const queryParams = new URLSearchParams();

      if (filterData.name?.trim()) {
        queryParams.append("name", filterData.name.trim());
      }

      if (filterData.phone?.trim()) {
        queryParams.append("phone", filterData.phone.trim());
      }

      if (filterData.lead_source_id) {
        queryParams.append("lead_source_id", filterData.lead_source_id);
      }

      if (filterData.lead_status_id) {
        queryParams.append("lead_status_id", filterData.lead_status_id);
      }

      if (filterData.lead_employee_id) {
        queryParams.append("lead_employee_id", filterData.lead_employee_id);
      }

      setFilterParams(queryParams.toString()); // Store filter query
      await fetchLeadDatas(1, queryParams.toString()); // Fetch first page with filters

    } catch (error) {
      console.error("Error applying filters:", error);
    }
  };

  const handleReset = async () => {
    setFilterData({ name: "", company_name: "", email: "", phone_number: "" });
    await fetchLeadDatas();
  };

  const allCountries = Country.getAllCountries();

  // Convert countries into an object with states
  const StatesData = allCountries.reduce((acc, country) => {
    acc[country.name] = State.getStatesOfCountry(country.isoCode).map(
      (state) => state.name
    );
    return acc;
  }, {});

  const countryOptions = Country.getAllCountries().map((country) => ({
    label: country.name,
    value: country.isoCode,
  }));

  // Get states based on selected country
  const filteredStates = leadDetails.country_region_id
    ? State.getStatesOfCountry(leadDetails.country_region_id).map((state) => ({
      label: state.name,
      value: state.isoCode,
    }))
    : [];

  const filteredCities =
    leadDetails.state_id && leadDetails.country_region_id
      ? City.getCitiesOfState(
        leadDetails.country_region_id,
        leadDetails.state_id
      ).map((city) => ({
        label: city.name,
        value: city.name,
      }))
      : [];

  const handleAddLead = async () => {
    setLoading(true);
    setopenDialogBoxForLead(true);
    setIsEditing(false);
    setSaveBtnOpen(true);
    setSaveBtn("save");
    setLeadDetails({
      date: new Date().toISOString().split("T")[0],
      name: "",
      lead_status_id: "",
      lead_source_id: "",
      phone: "",
      email_address: "",
      lead_date: "",
      employees_id: [],
      lead_value: "",
      country_region_id: "",
      state_id: "",
      website: "",
      position: "",
      company: "",
      attention: "",
      street_address_1: "",
      street_address_2: "",
      city: "",
      pincode: "",
    });

    setLoading(false);
  };

  const handleChangeForLead = (e) => {
    const { name, value } = e.target;

    if (name === "phone" && value.length === 10) {
      handleChangePhone(value);
    } else {
      setLeadDetails({
        date: new Date().toISOString().split("T")[0],
        name: "",
        lead_status_id: "",
        lead_source_id: "",
        phone: "",
        email_address: "",
        lead_date: "",
        employees_id: [],
        lead_value: "",
        country_region_id: "",
        state_id: "",
        website: "",
        position: "",
        company: "",
        attention: "",
        street_address_1: "",
        street_address_2: "",
        city: "",
        pincode: "",
      });
    }

    setLeadDetails((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "country_region_id" ? { state_id: "", city: "" } : {}), // Reset state & city if country changes
      ...(name === "state_id" ? { city: "" } : {}), // Reset city if state changes
    }));
  };

  const handleSubmitForLead = async (e) => {
    e.preventDefault();


    try {
      const response = await axios.post(
        "public/api/admin/lead/store",
        leadDetails,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      toast.success(response.data.message);
      setopenDialogBoxForLead(false);
      await fetchLeadDatas();
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };

  const handleChangePhone = async (phone) => {
    console.log(phone);
    try {
      const response = await axios.get("public/api/admin/lead/phone", {
        params: { phone },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      console.log(response?.data?.lead, "phone");
      if (response?.data?.lead) {
        setLeadDetails({
          date: response?.data?.lead.date?.split(" ")[0],
          name: response?.data?.lead.name,
          lead_status_id: response?.data?.lead.lead_status?.id,
          lead_source_id: response?.data?.lead.lead_source?.id,
          phone: response?.data?.lead.phone,
          email_address: response?.data?.lead.email_address,
          lead_date: response?.data?.lead.lead_date,
          lead_value: response?.data?.lead.lead_value,
          employees_id: response?.data?.lead.lead_employee
            ? response?.data?.lead.lead_employee.map((item) => item.id)
            : [],
          country_region_id: response?.data?.lead.country_region_id,
          state_id: response?.data?.lead.state_id,
          city: response?.data?.lead.city,
          street_address_1: response?.data?.lead.street_address_1,
          street_address_2: response?.data?.lead.street_address_2,
          pincode: response?.data?.lead.pincode,
          website: response?.data?.lead.website,
          company: response?.data?.lead.company,
          attention: response?.data?.lead.attention,
          position: response?.data?.lead.position,
          type_of_work: response?.data?.lead.type_of_work.map((item) => item.id),
        });
      }

      toast.success(response.data.message);
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message);
    }
  }

  const handleEditForLead = async (id_crypt) => {
    setIsEditing(false);
    toast.success("Now You Can Edit This Lead");
    setSaveBtnOpen(true);
    setSaveBtn("update");
    try {
      const response = await axios.get(
        `public/api/admin/lead/edit/${id_crypt}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );



      setLeadDetails({
        date: response.data.leads.date?.split(" ")[0],
        name: response.data.leads.name,
        lead_status_id: response.data.leads.lead_status?.id,
        lead_source_id: response.data.leads.lead_source?.id,
        phone: response.data.leads.phone,
        email_address: response.data.leads.email_address,
        lead_date: response.data.leads.lead_date,
        lead_value: response.data.leads.lead_value,
        employees_id: response.data.leads.lead_employee
          ? response.data.leads.lead_employee.map((item) => item.id)
          : [],
        country_region_id: response.data.leads.country_region_id,
        state_id: response.data.leads.state_id,
        city: response.data.leads.city,
        street_address_1: response.data.leads.street_address_1,
        street_address_2: response.data.leads.street_address_2,
        pincode: response.data.leads.pincode,
        website: response.data.leads.website,
        company: response.data.leads.company,
        attention: response.data.leads.attention,
        position: response.data.leads.position,
        type_of_work: response.data?.leads.type_of_work.map((item) => item.id),

      });
    } catch (error) {
      toast.error(error.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateForLead = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.put(
        `public/api/admin/lead/update/${editId}`,
        leadDetails,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );


      toast.success(response.data.message);
      setopenDialogBoxForLead(false);
      await fetchLeadDatas();
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };

  // const openEditOption = () => {
  //   setIsOpenEdit(!isOpenEdit); // Toggles the state
  // };

  const handleDialogClose = async () => {
    setLoading(true);
    try {
      await fetchLeadDatas();
      setopenDialogBoxForLead(false);

      // If showForm is true, reset to false and redirect to Dashboard
      if (showForm) {
        navigate('/crm/lead_dashboard'); // Redirect to Dashboard
      } else {
        navigate(location.pathname, {
          state: { ...location.state, showForm: false }
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };




  return (
    <>
      {loading ? (
        <div className="h-screen bg-white">
          <div className="flex justify-center items-center h-full">
            <img
              className="h-16 w-16"
              src="https://icons8.com/preloaders/preloaders/1488/Iphone-spinner-2.gif"
              alt="loader"
            />
          </div>
        </div>
      ) : (
        <>

          <LabelTopView label="Leads Overview" icon={<ChartBarBigIcon />} />


          <TopStats statsFieldNames={statsFieldNames} />

          <HeaderWithButton
            title="Lead"
            description="lead"
            buttonText="Lead"
            onButtonClick={handleAddLead}
            showButton={leadPermission}

          />

          <TopFilters
            fields={fields}
            filterData={filterData}
            handleChange={handleChange}
            handleFilter={handleFilter}
            handleReset={handleReset}
          />

          <LeadList
            setopenDialogBoxForLead={setopenDialogBoxForLead}
            setLeadDetails={setLeadDetails}
            setSaveBtn={setSaveBtn}
            setLoading={setLoading}
            leadPaginationData={leadPaginationData}
            setEditId={setEditId}
            fetchLeadDatas={fetchLeadDatas}
            setIsEditing={setIsEditing}
            setSaveBtnOpen={setSaveBtnOpen}
            setEditLeadIdCrypty={setEditLeadIdCrypty}
            id_crypt={id_crypt}
            showForm={showForm}
            filterParams={filterParams}
          />
          {openDialogBoxForLead && (
            <Dialog
              open={openDialogBoxForLead}
              onClose={() => { }}
              className="relative z-10"
            >
              <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />

              <div className="fixed inset-0 z-10 overflow-y-auto">
                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                  <Dialog.Panel className="my-auto relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all w-full sm:w-full md:max-w-screen-sm lg:max-w-screen-xl h-full sm:h-auto max-h-[90vh] overflow-y-auto ">
                    <div
                      className="flex justify-between p-4 text-white sticky top-0 z-50"
                      style={{ backgroundColor: "#6366f1" }}
                    >
                      <h1 className="mx-auto sm:px-6 sm:mx-0 md:px-8 sm:text-lg font-medium uppercase ">
                        Lead Management
                      </h1>
                      <div className="flex gap-2">

                        {isEditing && (
                          <div className="relative">
                            <button
                              type="button"
                              className="inline-flex items-center gap-x-1 text-sm/6 font-semibold text-gray-900"
                              aria-expanded={isOpenEdit}
                            >
                              <PencilSquareIcon
                                // onClick={() => setIsOpenEdit(!isOpenEdit)} // Toggle visibility
                                onClick={() => {
                                  handleEditForLead(editLeadIdCrypty);
                                  setIsOpenEdit(false); // Close after clicking Edit
                                }}
                                className="h-6 w-6 cursor-pointer text-white"
                              />
                            </button>

                            {/* {isOpenEdit && (
                              <div className="absolute left-1/2 z-10 mt-5 flex w-screen max-w-min -translate-x-1/2 px-4">
                                <div className="w-56 shrink rounded-xl bg-white p-4 text-sm/6 font-semibold text-gray-900 ring-1 shadow-lg ring-gray-900/5">
                                  <a
                                    href="#"
                                    className="block p-2 hover:text-indigo-600"
                                    onClick={() => {
                                      handleEditForLead(editLeadIdCrypty);
                                      setIsOpenEdit(false); // Close after clicking Edit
                                    }}
                                  >
                                    Edit
                                  </a>
                                </div>
                              </div>
                            )} */}
                          </div>
                        )}
                        <XMarkIcon
                          onClick={handleDialogClose}
                          className="h-6 w-6 cursor-pointer"
                        />
                      </div>
                    </div>
                    {/* <HeaderWithAction
  title="Lead Management"
  handleClose={handleDialogClose}
  isEditing={isEditing}
  handleEdit={() => handleEditForLead(editLeadIdCrypty)}
  showButton={leadPermissionForEdit}

/> */}
                    <div className="md:grid md:gap-6 p-4">
                      <div className="md:mt-0 md:col-span-2">
                        <form className="space-y-6 shadow-xl rounded">
                          <div className=" overflow-hidden">
                            <div className="p-6">
                              <div className="grid grid-cols-6 gap-6 ">
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <div className="flex items-center space-x-2">
                                    <label
                                      htmlFor="end_date"
                                      className="block text-sm font-medium leading-6 text-gray-900"
                                    >
                                      Date
                                    </label>
                                  </div>
                                  <input
                                    type="date"
                                    name="date"
                                    value={leadDetails?.date}
                                    // disabled={isEditing}
                                    disabled
                                    onChange={handleChangeForLead}
                                    min={new Date().toISOString().split("T")[0]}
                                    className="block w-full mt-2 bg-gray-100 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                  />
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="end_date"
                                    className="block text-sm font-medium leading-6 text-gray-900"
                                  >
                                    Name
                                  </label>
                                  <input
                                    type="text"
                                    name="name"
                                    value={leadDetails?.name}
                                    onChange={handleChangeForLead}
                                    className={`block w-full ${isEditing && "bg-gray-100"
                                      }  mt-2 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                    placeholder="Name"
                                    disabled={isEditing}
                                  />
                                  {requiredFields.name && (
                                    <p className="mt-1 text-sm text-red-600">
                                      {requiredFields.name}
                                    </p>
                                  )}
                                </div>

                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label className="block text-sm font-medium leading-6 text-gray-900">
                                    Phone{" "}
                                    <span className="text-red-600">*</span>
                                  </label>
                                  <div className="mt-2">
                                    <input
                                      name="phone"
                                      type="number"
                                      value={leadDetails?.phone}
                                      onChange={handleChangeForLead}
                                      placeholder="Phone"
                                      className={`block w-full ${isEditing && "bg-gray-100"
                                        }  mt-2 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                      disabled={isEditing}
                                    />
                                  </div>
                                  {requiredFields.phone && (
                                    <p className="mt-1 text-sm text-red-600">
                                      {requiredFields.phone}
                                    </p>
                                  )}
                                </div>
                              </div>

                              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-5">
                                {/* Expected Delivery Date */}
                                <div className="w-full">
                                  <label
                                    htmlFor="expected_delivery_date"
                                    className="block text-sm font-medium "
                                  >
                                    Lead Source
                                  </label>
                                  <Select
                                    name="lead_source_id"
                                    options={leadSourceData?.map((source) => ({
                                      value: source.id,
                                      label: source.name,
                                    }))} // Convert sources to the correct format
                                    value={
                                      leadSourceData
                                        ?.filter(
                                          (source) =>
                                            source.id ===
                                            leadDetails?.lead_source_id
                                        )
                                        ?.map((source) => ({
                                          value: source.id,
                                          label: source.name,
                                        })) || null
                                    } // Ensuring selected value is correctly displayed
                                    onChange={(selectedOption) =>
                                      handleChangeForLead({
                                        target: {
                                          name: "lead_source_id",
                                          value: selectedOption?.value,
                                        },
                                      })
                                    }
                                    className="w-full mt-2"
                                    classNamePrefix="select "
                                    placeholder="Select Lead Source"
                                    isDisabled={isEditing}
                                  />

                                  {requiredFields.lead_source_id && (
                                    <p className="mt-1 text-sm text-red-600">
                                      {requiredFields.lead_source_id}
                                    </p>
                                  )}
                                </div>

                                {/* Order Prefix */}
                                <div className="w-full">
                                  <label
                                    htmlFor="order_prefix"
                                    className="block text-sm font-medium leading-6 text-gray-900"
                                  >
                                    Status
                                  </label>
                                  <Select
                                    name="lead_status_id"
                                    options={leadStatusData?.map((status) => ({
                                      value: status.id,
                                      label: status.name,
                                    }))} // Convert statuses to the correct format
                                    value={
                                      leadStatusData
                                        ?.filter(
                                          (status) =>
                                            status.id ===
                                            leadDetails?.lead_status_id
                                        )
                                        ?.map((status) => ({
                                          value: status.id,
                                          label: status.name,
                                        })) || null
                                    } // Ensuring selected value is correctly displayed
                                    onChange={(selectedOption) =>
                                      handleChangeForLead({
                                        target: {
                                          name: "lead_status_id",
                                          value: selectedOption?.value,
                                        },
                                      })
                                    }
                                    className="w-full mt-2 "
                                    classNamePrefix="select"
                                    placeholder="Select Status"
                                    isDisabled={isEditing}
                                  />

                                  {requiredFields.lead_status_id && (
                                    <p className="mt-1 text-sm text-red-600">
                                      {requiredFields.lead_status_id}
                                    </p>
                                  )}
                                </div>

                                {/* Employees No */}
                                <div className="w-full">
                                  <label
                                    htmlFor="employees_id"
                                    className="block text-sm font-medium leading-6 text-gray-900"
                                  >
                                    Employees
                                  </label>
                                  <Select
                                    isMulti
                                    name="employees_id"
                                    options={employeesList?.map((employee) => ({
                                      value: employee.id,
                                      label: employee.name,
                                    }))} // Convert employee list to react-select format
                                    value={employeesList
                                      .filter((employee) =>
                                        leadDetails?.employees_id?.includes(
                                          employee.id
                                        )
                                      )
                                      .map((employee) => ({
                                        value: employee.id,
                                        label: employee.name,
                                      }))}
                                    onChange={(selectedOptions) => {
                                      handleChangeForLead({
                                        target: {
                                          name: "employees_id",
                                          value: selectedOptions.map(
                                            (option) => option.value
                                          ),
                                        },
                                      });
                                    }}
                                    className="w-full mt-2 "
                                    classNamePrefix="select"
                                    isDisabled={isEditing}
                                  />

                                  {requiredFields.employees_id && (
                                    <p className="mt-1 text-sm text-red-600">
                                      {requiredFields.employees_id}
                                    </p>
                                  )}
                                </div>

                                <div className="w-full">
                                  <label
                                    htmlFor="order_no"
                                    className="block text-sm font-medium leading-6 text-gray-900"
                                  >
                                    Lead Value
                                  </label>
                                  <input
                                    name="lead_value"
                                    type="text"
                                    value={leadDetails?.lead_value}
                                    onChange={handleChangeForLead}
                                    placeholder="Lead value"
                                    className={`block w-full ${isEditing && "bg-gray-100"
                                      }  mt-2 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                    disabled={isEditing}
                                  />
                                  {requiredFields.lead_value && (
                                    <p className="mt-1 text-sm text-red-600">
                                      {requiredFields.lead_value}
                                    </p>
                                  )}
                                </div>

                                {/* type of work */}
                                <div className="w-full">
                                  <label
                                    htmlFor="order_prefix"
                                    className="block text-sm font-medium leading-6 text-gray-900"
                                  >
                                    Type Of Work
                                  </label>
                                  <Select
                                    isMulti
                                    name="type_of_work"
                                    options={typeOfWork?.map((type) => ({
                                      value: type.id,
                                      label: type.name,
                                    }))}
                                    value={
                                      typeOfWork
                                        ?.filter((type) =>
                                          (leadDetails?.type_of_work || []).includes(type.id)
                                        )
                                        ?.map((type) => ({
                                          value: type.id,
                                          label: type.name,
                                        })) || []
                                    }
                                    onChange={(selectedOptions) =>
                                      handleChangeForLead({
                                        target: {
                                          name: "type_of_work",
                                          value: selectedOptions?.map((option) => option.value) || [],
                                        },
                                      })
                                    }
                                    className="w-full mt-2"
                                    classNamePrefix="select"
                                    placeholder="Select Type of Work"
                                    isDisabled={isEditing}
                                  />


                                  {requiredFields.type_of_work && (
                                    <p className="mt-1 text-sm text-red-600">
                                      {requiredFields.type_of_work}
                                    </p>
                                  )}
                                </div>
                              </div>

                              <h2 className="text-md font-semibold sm:text-md font-semibold text-gray-900  mb-4 mt-5">
                                CONTACT INFO
                              </h2>

                              <div className="grid grid-cols-6 gap-6 ">
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <div className="flex items-center space-x-2">
                                    <label
                                      htmlFor="end_date"
                                      className="block text-sm font-medium leading-6 text-gray-900"
                                    >
                                      Position
                                    </label>
                                  </div>
                                  <input
                                    type="text"
                                    name="position"
                                    value={leadDetails?.position}
                                    onChange={handleChangeForLead}
                                    placeholder="Position"
                                    className={`block w-full ${isEditing && "bg-gray-100"
                                      }  mt-2 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                    disabled={isEditing}
                                  />
                                  {requiredFields.position && (
                                    <p className="mt-1 text-sm text-red-600">
                                      {requiredFields.position}
                                    </p>
                                  )}
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="end_date"
                                    className="block text-sm font-medium leading-6 text-gray-900"
                                  >
                                    Email{" "}
                                    <span className="text-red-600">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    name="email_address"
                                    value={leadDetails?.email_address}
                                    onChange={handleChangeForLead}
                                    className={`block w-full ${isEditing && "bg-gray-100"
                                      }  mt-2 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                    disabled={isEditing}
                                    placeholder="Email"
                                  />
                                  {requiredFields.email_address && (
                                    <p className="mt-1 text-sm text-red-600">
                                      {requiredFields.email_address}
                                    </p>
                                  )}
                                </div>

                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label className="block text-sm font-medium leading-6 text-gray-900">
                                    Website
                                  </label>
                                  <div className="mt-2">
                                    <input
                                      name="website"
                                      type="text"
                                      value={leadDetails?.website}
                                      onChange={handleChangeForLead}
                                      placeholder="Website"
                                      className="block w-full  rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                    />
                                  </div>
                                  {requiredFields.website && (
                                    <p className="mt-1 text-sm text-red-600">
                                      {requiredFields.website}
                                    </p>
                                  )}
                                </div>
                              </div>

                              <h2 className="text-md font-semibold sm:text-md font-semibold text-gray-900  mb-4 mt-5">
                                ADDRESS DETAILS
                              </h2>

                              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-6">
                                <div className="w-full">
                                  <div className="flex items-center space-x-2">
                                    <label
                                      htmlFor="end_date"
                                      className="block text-sm font-medium leading-6 text-gray-900"
                                    >
                                      Company
                                    </label>
                                  </div>
                                  <input
                                    type="text"
                                    name="company"
                                    value={leadDetails?.company}
                                    onChange={handleChangeForLead}
                                    placeholder="Company"
                                    className={`block w-full ${isEditing && "bg-gray-100"
                                      }  mt-2 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                    disabled={isEditing}
                                  />
                                  {requiredFields.company && (
                                    <p className="mt-1 text-sm text-red-600">
                                      {requiredFields.company}
                                    </p>
                                  )}
                                </div>
                                <div className="w-full">
                                  <label
                                    htmlFor="end_date"
                                    className="block text-sm font-medium leading-6 text-gray-900"
                                  >
                                    Attention
                                  </label>
                                  <input
                                    type="text"
                                    name="attention"
                                    value={leadDetails?.attention}
                                    onChange={handleChangeForLead}
                                    className={`block w-full ${isEditing && "bg-gray-100"
                                      }  mt-2 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                    disabled={isEditing}
                                    placeholder="Attention"
                                  />
                                  {requiredFields.attention && (
                                    <p className="mt-1 text-sm text-red-600">
                                      {requiredFields.attention}
                                    </p>
                                  )}
                                </div>

                                <div className="w-full">
                                  <label className="block text-sm font-medium leading-6 text-gray-900">
                                    Country / Region
                                  </label>
                                  <div className="mt-2">
                                    <select
                                      name="country_region_id"
                                      value={
                                        leadDetails?.country_region_id || ""
                                      }
                                      onChange={handleChangeForLead}
                                      className={`block w-full ${isEditing && "bg-gray-100"
                                        }  mt-2 rounded-md border-0 py-1.5  text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                      disabled={isEditing}
                                    >
                                      <option value="" disabled>
                                        Select Country / Region
                                      </option>
                                      {countryOptions.map((country) => (
                                        <option
                                          key={country.value}
                                          value={country.value}
                                        >
                                          {country.label}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                  {requiredFields.country_region_id && (
                                    <p className="mt-1 text-sm text-red-600">
                                      {requiredFields.country_region_id}
                                    </p>
                                  )}
                                </div>
                              </div>

                              <div className="grid grid-cols-6 gap-3 ">
                                <div className="col-span-6 mt-2  sm:mt-8 sm:col-span-6 lg:col-span-2">
                                  <label className="block text-sm font-medium leading-6 text-gray-900">
                                    State
                                  </label>
                                  <div className="mt-2">
                                    <select
                                      name="state_id"
                                      value={leadDetails?.state_id || ""}
                                      onChange={handleChangeForLead}
                                      className={`block w-full ${isEditing && "bg-gray-100"
                                        }  mt-2 rounded-md border-0  py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                      // disabled={isEditing}
                                      disabled={
                                        !leadDetails.country_region_id ||
                                        isEditing
                                      } // Disable if no country is selected
                                    >
                                      <option value="" disabled>
                                        Select State / Province
                                      </option>
                                      {filteredStates.map((state) => (
                                        <option
                                          key={state.value}
                                          value={state.value}
                                        >
                                          {state.label}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                  {requiredFields.state_id && (
                                    <p className="mt-1 text-sm text-red-600">
                                      {requiredFields.state_id}
                                    </p>
                                  )}
                                </div>

                                <div className="col-span-6 mt-2  sm:mt-8 sm:col-span-6 lg:col-span-2">
                                  <label className="block text-sm font-medium leading-6 text-gray-900">
                                    City
                                  </label>
                                  <div className="mt-2">
                                    <select
                                      name="city"
                                      value={leadDetails?.city || ""}
                                      onChange={handleChangeForLead}
                                      className={`block w-full ${isEditing && "bg-gray-100"
                                        } rounded-md border-0 py-1.5  text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm`}
                                      disabled={
                                        !leadDetails.state_id || isEditing
                                      } // Disable if no state is selected
                                    >
                                      <option value="" disabled>
                                        Select City
                                      </option>
                                      {filteredCities.map((city) => (
                                        <option
                                          key={city.value}
                                          value={city.value}
                                        >
                                          {city.label}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                  {requiredFields.city && (
                                    <p className="mt-1 text-sm text-red-600">
                                      {requiredFields.city}
                                    </p>
                                  )}
                                </div>

                                <div className="col-span-6 mt-2  sm:mt-8 sm:col-span-6 lg:col-span-2">
                                  <label className="block text-sm font-medium leading-6 text-gray-900">
                                    Pincode
                                  </label>
                                  <div className="mt-2">
                                    <input
                                      name="pincode"
                                      type="number"
                                      value={leadDetails?.pincode}
                                      onChange={handleChangeForLead}
                                      className={`block w-full ${isEditing && "bg-gray-100"
                                        }  rounded-md border-0 py-1.5  text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                      disabled={isEditing}
                                      placeholder="Pincode"
                                    />
                                  </div>
                                  {requiredFields.pincode && (
                                    <p className="mt-1 text-sm text-red-600">
                                      {requiredFields.pincode}
                                    </p>
                                  )}
                                </div>
                              </div>

                              <div className="grid mt-4 sm:mt-4 grid-cols-4 gap-3 ">
                                <div className="col-span-6 mt-4 sm:mt-8 sm:col-span-6 lg:col-span-2">
                                  <div className="flex items-center space-x-2 ">
                                    <label
                                      htmlFor="end_date"
                                      className="block text-sm font-medium leading-6 text-gray-900"
                                    >
                                      Street Address 1
                                    </label>
                                  </div>
                                  <textarea
                                    type="date"
                                    name="street_address_1"
                                    placeholder="Street Address 1"
                                    rows={3}
                                    value={leadDetails?.street_address_1}
                                    onChange={handleChangeForLead}
                                    className={`block w-full ${isEditing && "bg-gray-100"
                                      }  mt-2 rounded-md border-0  py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                    disabled={isEditing}
                                  />
                                  {requiredFields.street_address_1 && (
                                    <p className="mt-1 text-sm text-red-600">
                                      {requiredFields.street_address_1}
                                    </p>
                                  )}
                                </div>
                                <div className="col-span-6 mt-2 sm:mt-8 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="end_date"
                                    className="block text-sm font-medium leading-6 text-gray-900"
                                  >
                                    Street Address 2
                                  </label>
                                  <textarea
                                    type="text"
                                    name="street_address_2"
                                    rows={3}
                                    value={leadDetails?.street_address_2}
                                    onChange={handleChangeForLead}
                                    className={`block w-full ${isEditing && "bg-gray-100"
                                      }  mt-2 rounded-md border-0  py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                    disabled={isEditing}
                                    placeholder="Street Address 2"
                                  />
                                  {requiredFields.street_address_2 && (
                                    <p className="mt-1 text-sm text-red-600">
                                      {requiredFields.street_address_2}
                                    </p>
                                  )}
                                </div>
                              </div>

                              {/* Save Button */}
                              {/* {saveBtn === "save" && saveBtnOpen ? (
                                <div className="bg-white mt-6 flex justify-end">
                                  <button
                                    onClick={handleSubmitForLead}
                                    className="flex justify-end py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                  >
                                    Save
                                  </button>
                                </div>
                              ) : (
                                <div className="bg-white mt-6">
                                  <button
                                    onClick={handleUpdateForLead}
                                    className="flex justify-end py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                  >
                                    Update
                                  </button>
                                </div>
                              )} */}
                              <div className="flex justify-end">
                                {saveBtn === "save" && saveBtnOpen ? (
                                  <div className="bg-white mt-6 flex justify-end">
                                    <button
                                      onClick={handleSubmitForLead}
                                      className="flex justify-end py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                    >
                                      Save
                                    </button>
                                  </div>
                                ) : saveBtnOpen ? (
                                  <div className="bg-white mt-6">
                                    {/* <button
                                    onClick={handleUpdateForLead}
                                    className="flex justify-end py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                  >
                                    Update
                                  </button> */}

                                    <UpdateConfirmation
                                      id_crypt={editLeadIdCrypty}
                                      apiType="lead"
                                      fetchClientData={fetchLeadDatas}
                                      inputs={leadDetails}
                                      dialogClose={setopenDialogBoxForLead}
                                    />

                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </Dialog.Panel>
                </div>
              </div>
            </Dialog>
          )}
        </>
      )}
    </>
  );
}

export default LeadCreate;
